import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 320, p: 3 }}>
          <Paper elevation={0} sx={{ maxWidth: 500, width: "100%", p: 4, borderRadius: "18px", textAlign: "center", border: "1px solid rgba(211,47,47,0.15)", backgroundColor: "rgba(255,235,235,0.5)" }}>
            <ErrorOutlineIcon sx={{ fontSize: 48, color: "#d32f2f", mb: 1.5 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#b71c1c", mb: 1 }}>
              Something went wrong
            </Typography>
            <Typography variant="body2" sx={{ color: "#666", mb: 2.5 }}>
              An unexpected error occurred in this section. Your other work is unaffected.
            </Typography>
            <Button
              variant="contained"
              size="small"
              sx={{ backgroundColor: "#d32f2f", borderRadius: "10px", textTransform: "none", fontWeight: 700, "&:hover": { backgroundColor: "#b71c1c" } }}
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Try Again
            </Button>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
